import { useMemo } from "react"
import { KTitleSpan } from "kahuna-base-react-components"
import { TrackEarning } from "../../../../types"
import earningsTableColumns from "./table-columns/earningsTableColumns"
import TableNew from "../../../ui/table/TableNew"
import { lang } from "../../../../constants/languages"

const EarningsTable = ({
  trackEarnings,
  pageNumber,
  setPageNumber,
  count,
  limit
}: {
  trackEarnings: TrackEarning[]
  pageNumber: number
  setPageNumber: (pageNumber: number) => void
  count: number
  limit: number
}) => {
  const columns = useMemo(() => earningsTableColumns(), [])

  return (
    <div className="w-full">
      <TableNew
        title={<KTitleSpan text={lang.royalties.earnings.table_title} fontSize={20} lineHeight="24px" />}
        columns={columns}
        data={trackEarnings}
        count={count}
        limit={limit}
        onClickPage={(page: number) => setPageNumber(page)}
        pagination
        pageNumber={pageNumber}
        minRowCount={10}
        notFoundTitle={lang.not_found.trends.title}
        notFoundDesc={lang.not_found.trends.desc}
      />
    </div>
  )
}

export default EarningsTable
